import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { SummationGroupDataService } from "../../core/summationgroups.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";

@Component({
    selector: "crew-summationgroup",
    template: require('./summation-group.component.html')
})
export class SummationGroup extends DetailsBase<Nema.Crew.Model.ActivityTypeSummationGroup> {

    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('summationGroup') summationGroupEntity: Nema.Crew.Model.ActivityTypeSummationGroup,
        @Inject(SummationGroupDataService.Id) summationGroupDataService: SummationGroupDataService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, summationGroupEntity, summationGroupDataService, $log);

        (<any>this.entity.ActivityTypeSummationGroupMapping).load();
    }

    public entityName = "Activity Summation Group";

    public editStateName = "app.settings.summationgroups.edit";

    public listStateName = "app.settings.summationgroups";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/summationgroups/summation-group.component.ts